import { GetVinDetailParams } from '@/api/generated/endpoints/vehicle/vehicle.zod';

export function normalizeVinInput(value: string): string {
  return value.trim().toUpperCase();
}

export function isValidVinInput(value: string): boolean {
  return GetVinDetailParams.safeParse({ vin: normalizeVinInput(value) })
    .success;
}
